import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import { type ReactNode, useId } from 'react';

export type MetaIconProps = SvgIconProps;

export function MetaIcon(props: MetaIconProps): ReactNode {
  const gradientId2 = useId();
  const gradientId3 = useId();
  return (
    <SvgIcon viewBox="0 0 90 90" {...props}>
      <defs>
        <linearGradient
          gradientTransform="matrix(1 0 0 -1 0 92)"
          gradientUnits="userSpaceOnUse"
          id={gradientId2}
          x1="19.5097"
          x2="81.4794"
          y1="48.549"
          y2="45.4192"
        >
          <stop offset="0%" stopColor="rgb(0,100,225)" stopOpacity={1} />
          <stop offset="40%" stopColor="rgb(0,100,225)" stopOpacity={1} />
          <stop offset="83%" stopColor="rgb(0,115,238)" stopOpacity={1} />
          <stop offset="100%" stopColor="rgb(0,130,251)" stopOpacity={1} />
        </linearGradient>

        <linearGradient
          gradientTransform="matrix(1 0 0 -1 0 92)"
          gradientUnits="userSpaceOnUse"
          id={gradientId3}
          x1="12.9651"
          x2="12.9651"
          y1="33.3855"
          y2="56.2329"
        >
          <stop offset="0%" stopColor="rgb(0,130,251)" stopOpacity={1} />
          <stop offset="100%" stopColor="rgb(0,100,224)" stopOpacity={1} />
        </linearGradient>
      </defs>

      <path
        d="M 9.721 54.533 c 0 3.437 0.754 6.075 1.74 7.671 c 1.293 2.091 3.221 2.976 5.186 2.976 c 2.535 0 4.854 -0.629 9.324 -6.81 c 3.58 -4.954 7.799 -11.909 10.638 -16.269 l 4.807 -7.386 c 3.339 -5.13 7.205 -10.832 11.637 -14.697 c 3.618 -3.155 7.521 -4.907 11.449 -4.907 c 6.594 0 12.876 3.821 17.683 10.989 C 87.446 33.949 90 43.836 90 54.039 c 0 6.066 -1.196 10.522 -3.23 14.043 c -1.966 3.405 -5.796 6.807 -12.241 6.807 v -9.709 c 5.518 0 6.895 -5.07 6.895 -10.873 c 0 -8.269 -1.928 -17.445 -6.175 -24.002 c -3.014 -4.651 -6.92 -7.493 -11.217 -7.493 c -4.648 0 -8.388 3.505 -12.591 9.756 c -2.235 3.321 -4.529 7.368 -7.105 11.934 l -2.836 5.023 c -5.696 10.1 -7.139 12.4 -9.987 16.197 c -4.992 6.648 -9.255 9.167 -14.866 9.167 c -6.657 0 -10.867 -2.883 -13.474 -7.227 C 1.045 64.123 0 59.478 0 54.186 L 9.721 54.533 z"
        fill="rgb(0,129,251)"
      />

      <path
        d="M 7.665 26.785 c 4.457 -6.87 10.889 -11.674 18.265 -11.674 c 4.272 0 8.519 1.264 12.954 4.886 c 4.851 3.959 10.022 10.479 16.472 21.223 l 2.313 3.856 c 5.584 9.302 8.76 14.087 10.619 16.344 c 2.391 2.898 4.066 3.762 6.241 3.762 c 5.518 0 6.895 -5.07 6.895 -10.873 L 90 54.039 c 0 6.066 -1.196 10.522 -3.23 14.043 c -1.965 3.405 -5.796 6.807 -12.241 6.807 c -4.006 0 -7.555 -0.87 -11.48 -4.573 c -3.017 -2.842 -6.544 -7.89 -9.258 -12.428 L 45.72 44.405 c -4.05 -6.767 -7.765 -11.812 -9.915 -14.097 c -2.313 -2.457 -5.286 -5.424 -10.031 -5.424 c -3.84 0 -7.101 2.695 -9.831 6.817 L 7.665 26.785 z"
        fill={`url(#${gradientId2})`}
      />

      <path
        d="M 25.774 24.885 c -3.84 0 -7.101 2.695 -9.831 6.817 c -3.859 5.825 -6.222 14.5 -6.222 22.832 c 0 3.437 0.754 6.075 1.74 7.671 l -8.288 5.458 C 1.045 64.123 0 59.478 0 54.186 c 0 -9.624 2.642 -19.655 7.665 -27.401 c 4.457 -6.87 10.889 -11.674 18.265 -11.674 L 25.774 24.885 z"
        fill={`url(#${gradientId3})`}
      />
    </SvgIcon>
  );
}
